module.exports = __webpack_public_path__ + "static/media/react-hero-logo.2398310c.svg";